import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {TranslateModule} from '@ngx-translate/core';
import {TablerIconsModule} from 'angular-tabler-icons';
import {Account} from '@services/api/admin/admin-api.service';

/** Link di invito mostrato una sola volta: finche' non c'e' una casella SMTP l'amministratore lo inoltra lui. */
@Component({
  selector: 'app-invite-link-dialog',
  standalone: true,
  imports: [MatDialogModule, TranslateModule, TablerIconsModule],
  template: `
    <h2 mat-dialog-title>{{ 'admin.invite_ready' | translate }}</h2>
    <mat-dialog-content>
      <p class="dm-a-hint">{{ 'admin.invite_ready_text' | translate: {email: account.email} }}</p>
      <div class="dm-a-link-box">
        <code>{{ account.invite_link }}</code>
        <button type="button" class="dm-a-btn primary" (click)="copy()">
          <i-tabler [name]="copied ? 'check' : 'copy'" class="icon-18"></i-tabler>
          {{ (copied ? 'admin.copied' : 'admin.copy') | translate }}
        </button>
      </div>
      <p class="dm-a-hint">{{ 'admin.invite_validity' | translate }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button type="button" class="dm-a-btn ghost" mat-dialog-close>{{ 'admin.close' | translate }}</button>
    </mat-dialog-actions>
  `,
})
export class InviteLinkDialogComponent {
  account: Account = inject(MAT_DIALOG_DATA);
  copied = false;

  copy(): void {
    navigator.clipboard?.writeText(this.account.invite_link ?? '').then(() => (this.copied = true));
  }
}
